export default __webpack_public_path__ + "static/media/Poster-Swim Alone.6f6702a0.png";